<template>
    <App>
        <Header />
        <main :class="{ 'is-fixed': isFixed }">
            <slot />
        </main>
        <Footer />
        <dark-light-switch v-if="false" />
    </App>
</template>
<script>
import App from "../../App.vue";

export default {
    components: {
        App,
        Header: () =>
            import(
                /* webpackChunkName: "layouts-home-header" */ "./header.vue"
            ),
        Footer: () =>
            import(
                /* webpackChunkName: "layouts-home-footer" */ "./footer.vue"
            ),
        DarkLightSwitch: () =>
            import(
                /* webpackChunkName: "components-darkLightSwitch" */ "@/components/darkLightSwitch.vue"
            ),
    },
    data() {
        return {
            isFixed: false,
        };
    },
    mounted() {
        this.$store.dispatch("setTheme", "light");
        window.addEventListener("scroll", this.handleScroll);
    },
};
</script>
<style lang="scss" scoped>
main {
    min-height: 100vh;
    min-height: calc(
        calc(var(--vh, 1vh) * 100) - var(--top-nav-height, 80px) -
            var(--bottom-nav-height, 56px)
    );
}
</style>
